import request from '@/utils/request'


// 查询商家冻结资金列表
export function listMerchantFreeze(query) {
  return request({
    url: '/biz/admin/merchant/freeze/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询商家冻结资金分页
export function pageMerchantFreeze(query) {
  return request({
    url: '/biz/admin/merchant/freeze/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询商家冻结资金详细
export function getMerchantFreeze(data) {
  return request({
    url: '/biz/admin/merchant/freeze/detail',
    method: 'get',
    params: data
  })
}

// 新增商家冻结资金
export function addMerchantFreeze(data) {
  return request({
    url: '/biz/admin/merchant/freeze/add',
    method: 'post',
    data: data
  })
}

// 修改商家冻结资金
export function updateMerchantFreeze(data) {
  return request({
    url: '/biz/admin/merchant/freeze/edit',
    method: 'post',
    data: data
  })
}

// 删除商家冻结资金
export function delMerchantFreeze(data) {
  return request({
    url: '/biz/admin/merchant/freeze/delete',
    method: 'post',
    data: data
  })
}
